<template>
  <fh-container>
    <fh-title>Reseteo de Pin</fh-title>

    <fh-card>
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
        v-on:submit.prevent
      >

        <div class="grey--text">
          <p>
            Con este formulario usted puede solicitar un cambio de pin que le será enviado a su correo
            electrónico (registrado en la aplicación).
          </p>
          <p>
            El pin recién será cambiado si usted hace click en el enlace recibido por correo
            electrónico.
          </p>
          <p>
            Si el operador correspondiente a la cuenta ingresada no tiene un correo registrado, esta solicitud
            quedará sin efecto.
          </p>
        </div>

        <!-- Username -->
        <v-text-field
          label="Cuenta"
          v-model="codigoAcceso"
          :rules="codigoAccesoRules"
          @keyup.enter="handleRequestResetPin"
          autocomplete="username"
          inputmode="numeric"
          autofocus
          class="mb-1"
        ></v-text-field>

        <v-row justify="center" class="pt-3">
          <v-btn @click="handleRequestResetPin" color="primary">
            Enviar Correo
          </v-btn>
        </v-row>

      </v-form>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import FhCard from '@/components/FhCard'
import UsuarioRepository from '@/services/UsuarioRepository'
import { mapActions } from 'vuex'

export default {
  name: 'RequestResetPin',
  components: { FhCard, FhTitle, FhContainer },
  data () {
    return {
      valid: true,
      // Defer validation until first submit attempt
      isSubmit: false,
      codigoAcceso: '',
      codigoAccesoRules: [
        v => !this.isSubmit || !!v || 'Campo obligatorio',
        v => !this.isSubmit || this.validateCodigoAcceso(v),
      ],
    }
  },
  methods: {
    ...mapActions('snackbar', [
      'showSnackbar'
    ]),
    async handleRequestResetPin () {
      this.isSubmit = true
      try {
        if (!this.$refs.form.validate()) { return }

        await UsuarioRepository.solicitarResetPin(parseInt(this.codigoAcceso))
        this.showSnackbar(['Solicitud de reseteo realizada.', 'success'])
        this.$router.push({ name: 'Login' })
      } catch (e) {
        //
      }
    },
    validateCodigoAcceso(codigoAcceso) {
      if (codigoAcceso.length < 4 || codigoAcceso.length > 10) {
        return 'Número de cuenta inválido'
      }

      let codigoAccesoInt = parseInt(codigoAcceso)
      if (codigoAccesoInt > 2147483647) {
        return 'Número de cuenta inválido'
      }

      return true
    },
  }
}
</script>

<style scoped>

</style>
